import {useRoute, useRouter} from '@typed-router';
import {useTranslation} from '#imports';
import {pushVJoySnackbar} from '@maltjoy/core-vue';
import {PaymentRedirectionSuccessTypes} from '~/features';
import {eventBus} from '../events';

export function useRedirectionSnackbars(fromProjectView = false) {
    const route = useRoute();
    const router = useRouter();
    const {t} = useTranslation();

    const {paymentConfirmedMissionId, isPrepayment, paymentStatus, origin, payLaterEligibilitySuccess, clientPaymentDelay, warn, ...restQuery} =
        route.query;

    if (paymentConfirmedMissionId) {
        let message: string | undefined;
        const keySuffix = fromProjectView ? '.no-link' : '';
        if (
            paymentStatus &&
            [PaymentRedirectionSuccessTypes.Card, PaymentRedirectionSuccessTypes.WebCard].includes(
                paymentStatus as unknown as PaymentRedirectionSuccessTypes,
            )
        ) {
            if (isPrepayment === 'true') {
                message = t(`projectclient.payment.redirect.success.card${keySuffix}`, {0: paymentConfirmedMissionId});
            } else {
                message = t(`projectclient.payment.redirect.success.card.invoice.before.payment${keySuffix}`, {
                    0: paymentConfirmedMissionId,
                });
            }
        } else if (paymentStatus === PaymentRedirectionSuccessTypes.Transfer) {
            message = t(`projectclient.payment.redirect.success.transfer${keySuffix}`, {0: paymentConfirmedMissionId});
        }

        if (message) {
            pushVJoySnackbar({
                props: {message, duration: 10000},
            });
        }
    }
    if (origin === 'appraisal') {
        pushVJoySnackbar({
            props: {
                header: t('projectclient.general.appraisal.submitted.title'),
                message: t('projectclient.general.appraisal.submitted.message'),
                duration: 3000,
            },
        });
    }

    if (payLaterEligibilitySuccess === 'true') {
        const delay = clientPaymentDelay ? parseInt(clientPaymentDelay as string) : 30;
        eventBus.emit('displayPayLaterEligibilitySuccessModal', delay);
    }

    if (warn === 'paymentInProgress') {
        pushVJoySnackbar({
            props: {message: t('projectclient.general.payment.is.already.being.processed'), level: 'warning', duration: 3000},
        });
    }

    router.replace({path: route.path, query: restQuery});
}
